import React from "react";
import { FaFacebookSquare } from "react-icons/fa";
import { BsInstagram } from "react-icons/bs";
import { BsTwitter } from "react-icons/bs";
import { FaLinkedin } from "react-icons/fa";
import { BiLogoGithub } from "react-icons/bi";
import { VscSend } from "react-icons/vsc";
import MyImage from "../images/myimage.jpg";
import "animate.css";
import ScrollDown from "./ScrollDown";
import { Typewriter } from "react-simple-typewriter";

const Header = () => {
  return (
    <>
      <div className="header" id="home">
        <div className="headerCon">
          <div className="headIcons animate__animated animate__fadeInDown">
            <a
              href="https://www.facebook.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookSquare className="headIcon" />
            </a>
            <a
              href="https://www.instagram.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <BsInstagram className="headIcon" />
            </a>
          <a
  href="https://www.linkedin.com/in/juan-duque-085905295"
  target="_blank"
  rel="noopener noreferrer"
>
  <FaLinkedin className="headIcon" />
</a>
            <a
              href="https://github.com/juanduque5"
              target="_blank"
              rel="noopener noreferrer"
            >
              <BiLogoGithub className="headIcon" />
            </a>
          </div>

          <h1 className="head animate__animated animate__fadeInLeft">
            Juan Duque
          </h1>

          <p className="subHead animate__animated animate__fadeInRight">
            I'm a
            <Typewriter
              words={[
                " Automation Engineer",
                " PLC Programmer",
                " Software Engineer",

              ]}              
              loop="infinit"
              cursor
              cursorStyle="|"
              typeSpeed={70}
              deleteSpeed={50}
              delaySpeed={1000}
            />
          </p>

          <p className="subPara animate__animated animate__fadeInRight">
          I'm a Creative Automation and Software Specialist, passionate and dedicated to delivering innovative and efficient solutions.
          </p>

          <div className="headBtn">
            <a href="#contact">
              <button className="mainBtn animate__animated animate__fadeInUp">
                Contact 
                <VscSend className="btnSpan" />
              </button>
            </a>
          </div>
        </div>

        <div className="headerImg">
          <img src={MyImage} alt="" />
        </div>
      </div>
      <div>
          <ScrollDown />
      </div>
    
    </>
  );
};

export default Header;
